import { HasId, ID } from "@libs/interfaces/layouts"
import { getStorage } from "@/settings/zustand"
import { create } from "zustand"
import { createJSONStorage, devtools, persist } from "zustand/middleware"

export const useDataStore: any = create( devtools( (set: any, get: any ) => ({
    addTo: (data_type: "string", arr: HasId[] ) => {
        let data: HasId[] = useDataStore.getState()[data_type] || []
        const ids: ID[] = data.map(dd => dd.id)
        let data1: HasId[] = [];
        arr.forEach( el => {
            if( !ids.includes(el.id) ) {
                data1.push(el)
            }
        })
        data = data.concat( data1 )
        //console.log( arr, data1, data )
        useDataStore.setState({[data_type] : data})
    }

})))